export default "assets/btn-arrow-10805966.svg";